var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconApple = function SvgIconApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 12.598a4.75 4.75 0 0 1 2.262-3.985 4.863 4.863 0 0 0-3.831-2.071c-1.612-.17-3.175.964-3.996.964-.837 0-2.102-.948-3.464-.92a5.102 5.102 0 0 0-4.293 2.619c-1.857 3.214-.472 7.938 1.306 10.536.89 1.272 1.93 2.693 3.29 2.643 1.332-.055 1.83-.85 3.436-.85 1.593 0 2.06.85 3.447.818 1.43-.023 2.33-1.278 3.188-2.562a10.524 10.524 0 0 0 1.457-2.969 4.59 4.59 0 0 1-2.802-4.223ZM15.077 4.832a4.677 4.677 0 0 0 1.07-3.35 4.758 4.758 0 0 0-3.079 1.593A4.451 4.451 0 0 0 11.97 6.3a3.935 3.935 0 0 0 3.107-1.469Z",
    fill: "currentColor"
  })));
};

export default SvgIconApple;